import ConexionRechazadaComponent from '@/components/shared/ConexionRechazadaComponent'


export default [{
    path: '/error-de-conexion',
    name: 'error-de-conexion',
    component: ConexionRechazadaComponent,
    meta: {
        requiresAuth: false
    }
}, ]